import type { ContactOutcome } from "@starsach/shared-types";

/** How an outcome reads on screen (requirements 8.4). */
export const OUTCOME_LABEL: Record<ContactOutcome, string> = {
  answered: "answered",
  contained: "contained",
  abandoned: "abandoned",
  transferred_out: "transferred out",
};

export const OUTCOME_TONE: Record<ContactOutcome, "ok" | "neutral" | "warning" | "critical"> = {
  answered: "ok",
  contained: "neutral",
  abandoned: "warning",
  transferred_out: "neutral",
};
